var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1667 7.16683V5.50016C12.1667 5.05814 11.9911 4.63421 11.6785 4.32165C11.366 4.00909 10.942 3.8335 10.5 3.8335H4.66667C4.22464 3.8335 3.80072 4.00909 3.48816 4.32165C3.17559 4.63421 3 5.05814 3 5.50016V15.5002C3 15.9422 3.17559 16.3661 3.48816 16.6787C3.80072 16.9912 4.22464 17.1668 4.66667 17.1668H10.5C10.942 17.1668 11.366 16.9912 11.6785 16.6787C11.9911 16.3661 12.1667 15.9422 12.1667 15.5002V13.8335M6.33333 10.5002H18M18 10.5002L15.5 8.00016M18 10.5002L15.5 13.0002",
    stroke: "#FD4F4F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.5275c18841dcab64b4fd7c43857fe32e.svg";
export { ForwardRef as ReactComponent };